import { forwardRef, ReactElement, useEffect, useImperativeHandle, useRef, useState } from "react";
import DataTable from "react-data-table-component";

interface Params {
  columns: any[];
  fetchData: any;
  refresh?: boolean;
  pagingOpt?: number[];    
  messageEmpty?: string | ReactElement;
  updateRow?: boolean;
  pageNo?: number;
  pagination?: boolean;
}

export interface TablePaginationRef {
  updateRowByIndex: (index: number, newRowData: any) => void;
}

const TablePagination = forwardRef<TablePaginationRef, Params>((props, ref) => {
  const {
    columns,
    fetchData,
    refresh,
    pagingOpt,
    messageEmpty,
    updateRow,
    pageNo,
    pagination
  } = props;
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const limit = useRef<number>(pagingOpt ? pagingOpt[0] : 10);

  useEffect(() => {
    handlePageChange(1);
  }, [refresh]);

  useEffect(() => {
    handlePageChange(pageNo ?? 1);
  }, [updateRow]);

  const handlePageChange = async (page: number) => {
    setLoading(true);
    const response = await fetchData(page, limit.current);
    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setLoading(true);
    limit.current = newPerPage;
    const response = await fetchData(page, newPerPage);
    setData(response.data.data);
    setLoading(false);
  };    

  const updateRowByIndex = (index: number, newRowData: any) => {
    setData(prevData => {
      const newData = [...prevData];
      newData[index] = newRowData;
      return newData;
    });
  };

  useImperativeHandle(ref, () => ({
    updateRowByIndex
  }));

  return (
    <DataTable
      columns={columns}
      data={data}
      highlightOnHover={true}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      responsive
      pagination={pagination == undefined ? true : pagination}
      paginationComponentOptions={
        {
          rowsPerPageText: 'Registros por página:',
          rangeSeparatorText: 'de',
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: 'Todos'
        }
      }
      progressPending={loading}
      progressComponent={
        <div uk-spinner="true; ratio:2">Carregando...</div>
      }
      paginationServer
      paginationTotalRows={totalRows}
      paginationRowsPerPageOptions={pagingOpt ? pagingOpt : [10, 25, 50, 100, 500]}
      paginationPerPage={limit.current}
      noDataComponent={            
        <div className='uk-flex uk-flex-middle uk-height-small'>                    
          {
            messageEmpty ? messageEmpty : 'Sem registros para serem exibidos!'
          }
          <span className="uk-margin-left" uk-icon="icon: happy; ratio: 2"></span>
        </div>
      }
    />
  );
})

export default TablePagination;